import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const GET_PLANOS_FINANCEIROS = "getPlanosFinanceiros";
export const GET_PLANOS_FINANCEIROS_LISTA = "getPlanosFinanceiroLista";

// mutation types
export const SET_PLANOS_FINANCEIROS = "setPlanosFinanceiros";

const state = {
  planosFinanceiros: []
};

const getters = {
  planosFinanceiros(state) {
    return state.planosFinanceiros;
  }
};

const actions = {
  [GET_PLANOS_FINANCEIROS](context) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.get("planosFinanceiros").then(({ data }) => {
          context.commit(SET_PLANOS_FINANCEIROS, data);
          resolve(data);
        });
      }
    });
  },
  [GET_PLANOS_FINANCEIROS_LISTA](context, filtros) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("planosFinanceirosLista", filtros).then(({ data }) => {
          resolve(data);
        });
      }
    });
  }
};

const mutations = {
  [SET_PLANOS_FINANCEIROS](state, planosFinanceiros) {
    state.planosFinanceiros = planosFinanceiros;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
